import { widgetPropType, permissionPropType } from 'constants';

import { compose, branch, renderNothing, setPropTypes } from 'recompose';

export default compose(
  setPropTypes({
    widget: widgetPropType,
    permissionProps: permissionPropType,
  }),
  branch((props) => {
    const { permissionProps, widget } = props;

    return !widget || !widget.isActive(permissionProps);
  }, renderNothing),
);
